import { BlazeUserConfigState } from 'store/blazeUserConfig/blazeUserConfigTypes';
import * as actionTypes from 'constants/action-types';
import { CLEAR_VIEW_AS_USER, SET_IS_PRIVATE_CLOUD_READ_ONLY, SET_VIEW_AS_USER } from 'constants/action-types';
import { BlazeUserConfigActionTypes } from 'store/blazeUserConfig/blazeUserConfigActionTypes';

const initialState: BlazeUserConfigState = {
  isLoading: true,
  blazeUserConfig: null,
  viewAsUser: null,
  isPrivateCloudReadOnly: false,
};

const reducer = (state = initialState, action: BlazeUserConfigActionTypes) => {
  switch (action.type) {
    case actionTypes.UPDATE_CURRENT_USER_DATA:
      return {
        ...state,
        blazeUserConfig: action.payload,
        isLoading: false,
      };
    case SET_VIEW_AS_USER: {
      return {
        ...state,
        viewAsUser: action.payload,
      };
    }
    case SET_IS_PRIVATE_CLOUD_READ_ONLY: {
      return {
        ...state,
        isPrivateCloudReadOnly: action.payload,
      };
    }
    case CLEAR_VIEW_AS_USER: {
      return {
        ...state,
        viewAsUser: null,
      };
    }
    case actionTypes.SET_VISITED_MS_PAGE: {
      const newBlazeUserConfig = state.blazeUserConfig;
      if (newBlazeUserConfig != null) {
        newBlazeUserConfig.user.visitedMockServices = true;
      }
      return {
        ...state,
        blazeUserConfig: newBlazeUserConfig,
      };
    }
    default:
      return state;
  }
};

export default reducer;
